import { orgCopy } from "@/lib/ui/org";

export const documentCollectionCopy = {
  label: "Коллекция",
  none: "Без коллекции",
  create: "Создать",
  pending: "Создаём…",
  nameLabel: "Новая коллекция",
  nameTaken: orgCopy.nameTaken,
  unknown: "Выберите коллекцию из списка",
  errorTitle: "Коллекция",
  open: "Открыть",
  missing: "Коллекция не найдена",
  pageDescription:
    "Право коллекции получают все текущие и новые файлы.",
  filesTitle: "Файлы",
  emptyFilesTitle: "Файлов нет",
  emptyFilesDescription:
    "Назначьте коллекцию на карточке документа.",
  columnFile: "Файл",
  columnStatus: "Статус",
} as const;

export function collectionHref(id: string): string {
  return `/documents/collections/${id}`;
}

export function documentCollectionLabel(name: string | null): string {
  return name?.trim() || documentCollectionCopy.none;
}

export function documentCollectionErrorMessage(code: string): string {
  if (code === "unknown-collection") {
    return documentCollectionCopy.unknown;
  }
  return code;
}
